
(function () {
  'use strict';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function matchesFocusVisible(el) {
    try { return el.matches(':focus-visible'); } catch (e) { return true; }
  }

  function Slideshow(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.track = root.querySelector('[data-hero-track]');
    this.pauseBtn = root.querySelector('[data-hero-pause]');
    this.index = 0;
    this.timer = null;
    this.holds = {};
    this.observer = null;
    this.destroyed = false;

    var seconds = parseInt(root.getAttribute('data-interval'), 10);
    this.interval = (seconds >= 3 ? seconds : 6) * 1000;

    this.paused = root.getAttribute('data-autoplay') !== 'true' || reduceMotion.matches;

    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].classList.contains('is-active')) { this.index = i; break; }
    }

    hydrate(this.slides[this.index]);

    if (this.slides.length < 2) return;
    this.bind();
    this.syncPause();
    this.schedule();

    var self = this;
    var warm = function () {
      var next = self.slides[(self.index + 1) % self.slides.length];
      if (window.requestIdleCallback) window.requestIdleCallback(function () { hydrate(next); });
      else setTimeout(function () { hydrate(next); }, 400);
    };
    if (document.readyState === 'complete') warm();
    else window.addEventListener('load', warm, { once: true });
  }

  function hydrate(slide) {
    if (!slide || slide.dataset.heroHydrated) return;
    slide.dataset.heroHydrated = '1';
    var sources = slide.querySelectorAll('source[data-srcset]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('srcset', sources[i].getAttribute('data-srcset'));
      sources[i].removeAttribute('data-srcset');
    }
    var imgs = slide.querySelectorAll('img[data-src]');
    for (var j = 0; j < imgs.length; j++) {
      var img = imgs[j];
      if (img.getAttribute('data-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.removeAttribute('data-srcset');
      }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    }
  }

  Slideshow.prototype.go = function (target) {
    var n = this.slides.length;
    if (n < 2) return;
    var i = ((target % n) + n) % n;

    if (i !== this.index) {
      var from = this.slides[this.index];
      var to = this.slides[i];
      hydrate(to);
      from.classList.remove('is-active');
      from.setAttribute('aria-hidden', 'true');
      from.setAttribute('inert', '');
      to.classList.add('is-active');
      to.removeAttribute('aria-hidden');
      to.removeAttribute('inert');
      this.index = i;
      this.dots.forEach(function (dot, k) {
        if (k === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    this.schedule();
  };

  Slideshow.prototype.running = function () {
    if (this.paused || this.destroyed) return false;
    for (var k in this.holds) {
      if (Object.prototype.hasOwnProperty.call(this.holds, k) && this.holds[k]) return false;
    }
    return true;
  };

  Slideshow.prototype.schedule = function () {
    clearTimeout(this.timer);
    this.timer = null;
    var running = this.running();
    if (this.track) this.track.setAttribute('aria-live', running ? 'off' : 'polite');
    if (!running) return;
    var self = this;
    this.timer = setTimeout(function () { self.go(self.index + 1); }, this.interval);
  };

  Slideshow.prototype.hold = function (reason, on) {
    this.holds[reason] = !!on;
    this.schedule();
  };

  Slideshow.prototype.syncPause = function () {
    var btn = this.pauseBtn;
    if (!btn) return;
    btn.setAttribute('data-state', this.paused ? 'paused' : 'playing');
    var label = btn.getAttribute(this.paused ? 'data-label-play' : 'data-label-pause');
    if (label) btn.setAttribute('aria-label', label);
  };

  Slideshow.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-hero-prev]')) { self.go(self.index - 1); return; }
      if (t.closest('[data-hero-next]')) { self.go(self.index + 1); return; }
      var dot = t.closest('[data-hero-dot]');
      if (dot) { self.go(parseInt(dot.getAttribute('data-hero-dot'), 10) || 0); return; }
      if (t.closest('[data-hero-pause]')) {
        self.paused = !self.paused;
        self.syncPause();
        self.schedule();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (!e.target || !e.target.closest || !e.target.closest('.hero__controls')) return;
      e.preventDefault();
      self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
    });

    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') self.hold('hover', true);
    });
    root.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') self.hold('hover', false);
    });

    root.addEventListener('focusin', function (e) {
      if (matchesFocusVisible(e.target)) self.hold('focus', true);
    });
    root.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) self.hold('focus', false);
    });

    var surface = this.track || root;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    surface.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      tracking = true;
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });
    surface.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      self.go(self.index + (dx < 0 ? 1 : -1));
    });
    surface.addEventListener('pointercancel', function () { tracking = false; });

    this.onVisibility = function () { self.hold('hidden', document.hidden); };
    document.addEventListener('visibilitychange', this.onVisibility);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        self.hold('offscreen', !entries[0].isIntersecting);
      });
      this.observer.observe(root);
    }
  };

  Slideshow.prototype.destroy = function () {
    this.destroyed = true;
    clearTimeout(this.timer);
    if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    if (this.observer) this.observer.disconnect();
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-hero-slider]');
    Array.prototype.forEach.call(roots, function (root) {
      if (!root.heroSlideshow) root.heroSlideshow = new Slideshow(root);
    });
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-hero-slider]');
    if (root && root.heroSlideshow) root.heroSlideshow.destroy();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-hero-slide]');
    var root = slide && slide.closest('[data-hero-slider]');
    if (!root || !root.heroSlideshow) return;
    var show = root.heroSlideshow;
    show.holds.editor = true;
    show.go(show.slides.indexOf(slide));
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-hero-slider]');
    if (root && root.heroSlideshow) root.heroSlideshow.hold('editor', false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
